import { MuPag, initDataAttributes, version } from "./index.js";
import type { MuPagWidgetNamespace } from "./types.js";

const namespace: MuPagWidgetNamespace = {
  MuPag,
  init: initDataAttributes,
  version,
};

if (typeof window !== "undefined") {
  window.MuPagWidget = namespace;
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initDataAttributes(document), { once: true });
  } else {
    initDataAttributes(document);
  }
}

export default namespace;
